import { render, staticRenderFns } from "./integralOrderDetail.vue?vue&type=template&id=20325198&scoped=true&"
import script from "./integralOrderDetail.vue?vue&type=script&lang=js&"
export * from "./integralOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./integralOrderDetail.vue?vue&type=style&index=0&id=20325198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20325198",
  null
  
)

export default component.exports